<div class="table mat-elevation-z8">
  <table
    mat-table
    [dataSource]="backendPagination ? data : dataSource"
    matSort
  >
    <ng-container
      *ngFor="let column of displayedColumns; let i = index"
      [matColumnDef]="column"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
      >
        {{ columnHeaders[i] || column }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
      >
        <div class="cell-content">
          {{ element[column] }}
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="headerColumns"
      class="table__header"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: headerColumns"
      (click)="onRowSelect(row)"
      [class.selected]="isSelected(row)"
      class="table__row"
    ></tr>
  </table>
  <div class="table__footer">
    <button
      mat-icon-button
      color="primary"
      (click)="onRefresh()"
      [disabled]="loading"
      aria-label="Refresh"
      class="table__refresh-btn"
      matTooltip="Refresh"
      matTooltipPosition="right"
    >
      <mat-icon>refresh</mat-icon>
    </button>
    <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 25, 50]"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
  <mat-progress-bar
    *ngIf="loading"
    mode="indeterminate"
  ></mat-progress-bar>
</div>
